import React from 'react'
import { useTranslation } from 'react-i18next'
import { Loading } from '../../atoms'
import { AmenitiesLoadingContainer } from './Amenities.styles'

export interface AmenitiesLoadingProps {
  className?: string
}

/**
 * AmenitiesLoading component displays a loading state while amenities data is being fetched.
 * Shows a spinner with informative text about the loading process.
 *
 * @param className - Optional CSS class name
 */
export const AmenitiesLoading: React.FC<AmenitiesLoadingProps> = ({
  className,
}) => {
  const { t } = useTranslation('amenities')

  return (
    <AmenitiesLoadingContainer className={className}>
      <Loading size="large" />
      <div
        style={{
          fontSize: '16px',
          fontWeight: '600',
          color: 'var(--text-primary)',
          marginBottom: '8px',
        }}
      >
        {t('loading.title')}
      </div>
      <div
        style={{
          fontSize: '14px',
          color: 'var(--text-secondary)',
          textAlign: 'center',
          maxWidth: '300px',
        }}
      >
        {t('loading.description')}
      </div>
    </AmenitiesLoadingContainer>
  )
}

export default AmenitiesLoading
